<!-- Container que decide qué versión renderizar según el flujo -->
<app-sales-request-credit-bureau-v3
  *ngIf="isFlowKrdya"
  (nextStepEvent)="onNextStep()">
</app-sales-request-credit-bureau-v3>